export default "/public/dist/img/distribuzioneItalia.png";